import React from 'react';
import { Typography } from '@mui/material';
import { LoadingSpinner } from './LoadingSpinner';
import DesignBuilder from './DesignBuilder';

interface DesignViewProps {
  templateId: string | undefined;
  templateGoalName: string | undefined;
  grpId: string;
  designTemplate: any;
  designLoading: boolean;
  designError: string;
  onProgramNameChange: (value: string) => void;
  registerSaveHandler: (handler: (() => Promise<boolean>) | null) => void;
  onDirtyChange: (dirty: boolean) => void;
}

/**
 * Post-creation "Program Design" surface (Program Settings "Program Design" tab +
 * the org-admin /designer view). Renders the Elliott stage-6 builder against the
 * live template — see DesignBuilder. The ATC heartbeat lives inside DesignBuilder.
 */
export function DesignView({
  templateId,
  templateGoalName,
  grpId,
  designTemplate,
  designLoading,
  designError,
  onProgramNameChange,
  registerSaveHandler,
  onDirtyChange
}: DesignViewProps) {
  if (designError) {
    return (
      <Typography fontSize={12} color="#F16063">
        {designError}
      </Typography>
    );
  }

  // Loading wins over the no-template message: while the route's group (and
  // with it the templateId) is still resolving, templateId is legitimately
  // undefined and "No template" would be a lie.
  if (designLoading) {
    return <LoadingSpinner minHeight={320} message="Loading Design" />;
  }

  if (!templateId) {
    return (
      <Typography fontSize={13} color="#B6B6B6">
        No template to this program
      </Typography>
    );
  }

  if (!designTemplate && !designError) {
    return <LoadingSpinner minHeight={320} message="Loading Design" />;
  }

  return (
    <DesignBuilder
      templateId={templateId}
      templateGoalName={templateGoalName}
      grpId={grpId}
      designTemplate={designTemplate}
      registerSaveHandler={registerSaveHandler}
      onDirtyChange={onDirtyChange}
      onProgramNameChange={onProgramNameChange}
    />
  );
}
